import { useQuery } from "@tanstack/react-query"
import { getUsersWallet } from "services/apiUserCreditManagement"

const useGetUsersCredits = (page,page_size,searchTerm,orgFilter) => {
  const {isPending,isSuccess,isError,error,data} = useQuery({
    queryKey:['usersCredits',page,page_size,searchTerm,orgFilter],
    queryFn: ()=>  getUsersWallet(page,page_size,searchTerm,orgFilter),
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000
  })

  return {isPending,isSuccess,isError,error,data}
}

export default useGetUsersCredits
